import styled from "styled-components";

const Page:any = styled.div.attrs(() => ({ className:"no-scrollbar" }))<any>`
    display:flex;
    height:100%;
    overflow-y:auto;
    overflow-x:hidden;
    flex-direction:column;
    align-items:${props => props.alignItems};
    text-align:${props => props.textAlign};
    width:100%;
    padding:${props => props.padding};
    background:${({theme , background}) => background ?? theme.colors.main.background};
    color:${({theme , color }) => color ?? theme.colors.main.text};
    font-family:${({theme}) => theme.fonts.primary};
    gap:${props => props.gap};
`;

Page.defaultProps = {
    "padding":"0 1rem 1rem 1rem",
    "alignItems":"center",
    "textAlign":"center",
}

export default Page;